import { render } from "./switch-control.vue?vue&type=template&id=56ce5424&scoped=true&ts=true"
import script from "./switch-control.vue?vue&type=script&lang=ts"
export * from "./switch-control.vue?vue&type=script&lang=ts"

import "./switch-control.vue?vue&type=style&index=0&id=56ce5424&lang=scss&scoped=true"

import exportComponent from "D:\\project\\fantan\\h5\\fantan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ce5424"]])

export default __exports__